import axios from '../../utils/axios';

const getEnrollmentStudents = async (
  {
    stage, name, page, limit, location, year,
  }: {
    stage?: string;
    name?: string;
    page?: number;
    limit?: number;
    location?: string;
    year?: number;
  } = {},
) => {
  const params: Record<string, string> = {};
  if (stage && stage !== 'all') params.stage = stage;
  if (name && name.trim().length > 0) params.name = name.trim();
  if (typeof page === 'number') params.page = String(page);
  if (typeof limit === 'number') params.limit = String(limit);
  if (location && location !== 'all') params.location = location;
  if (year) params.year = String(year);

  const response = await axios.get('/api/enrollment/students', { params });
  return response.data;
};

const getSchools = async () => {
  const response = await axios.get('/api/enrollment/schools');
  return response.data;
};

const postInitWebpay = async (studentId: string) => {
  const response = await axios.post(`/api/enrollment/init-webpay/${studentId}`);
  return response.data;
};

const postIncompleteStudent = async (student: {
  rut: string;
  name: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  schoolId?: string | null;
  otherSchoolName?: string | null;
  birthDate?: string | null;
  preferredLocationIds?: string[] | null;
  desiredClassYear?: string | null;
  inscriptionYear?: number | null;
  leadSource?: string | null;
  leadName?: string | null;
  ambassadorCode?: string | null;
}) => {
  const response = await axios.post('/api/enrollment/incomplete-student', student);
  return response.data;
};

const putFinishEnrollmentProcess = async (studentId: string) => {
  const response = await axios.put(`/api/enrollment/finish-process/${studentId}`);
  return response.data;
};

export {
  getEnrollmentStudents,
  getSchools,
  postInitWebpay,
  postIncompleteStudent,
  putFinishEnrollmentProcess,
};
